import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Icon } from 'react-icons-kit'
import { trashO, plus } from 'react-icons-kit/fa'
import { smallRight, smallLeft } from 'react-icons-kit/entypo'
import { Accordion, Card, Button, Modal } from 'react-bootstrap'
import API from '../Components/Global_API'
import NoInternet from '../Components/NoInternet';

const styles = {
    body: {
        backgroundColor: '#34baeb',
    },
    dot_btn: {
        borderWidth: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
    },
    done_btn: {
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        marginBottom: 30,
        color: '#fff',
        borderWidth: 1,
        borderColor: '#fff',
        fontWeight: 'bold'
    },
    disable_done_btn: {
        marginBottom: 30,
        color: '#fff',
        fontWeight: 'bold'
    },
    radio: {
        borderWidth: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
        margin: 5,
        paddingLeft: 20,
        borderRadius: 5,
        fontSize: 15,
        paddingTop: 5,
        width: '45%',
        height: 140
    },
    continue_button: {
        borderWidth: 2,
        borderColor: 'rgba(0,0,0,0.2)',
        padding: 10,
        backgroundColor: '#fff',
        color: '#000000'
    },
    text: {
        fontWeight: '700',
        fontSize: 13
    },
    textbox: {
        height: 30
    },
    previewbutton: {
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        marginBottom: 30,
        borderWidth: 1,
        padding: 20,
        borderColor: '#fff',
        color: '#fff',
        width: "100%",
    }
}

export default class Multiple_choice_image extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: '',
            answerText: '',
            correctAns: '',
            incorrectAns: '',
            prompt: '',
            done_text: '',
            user: [{ id: '1', image: '', correct_option: '' }, { id: '2', image: '', correct_option: '' }, { id: '3', image: '', correct_option: '' }, { id: '4', image: '', correct_option: '' }],
            // answer: '',
            lessonId: '',
            multiple_choice_image_id: '',
            course_image: this.props.course_image,
            done_button_state: true,
            done_button_name: this.props.data.prompt,
            answer_popup: true,
            answer_reinforcement: '',
            selected_value: '',
            contentValidation: false,
            img: '',
            prev_review: true,
            changeSectionStatus: '',
            PublishedSectionPopup: false,
            image_error_popup: false
        }

        this.state.title = this.props.data.title;
        this.state.answerText = this.props.data.answer_text;
        this.state.correctAns = this.props.data.correct_reinforcement;
        this.state.incorrectAns = this.props.data.incorrect_reinforcement;
        this.state.user = this.props.data.multiple_choice_image_options;
        this.state.done_text = this.props.data.done_text;
        this.state.prompt = this.props.data.prompt;
        this.state.answer = this.props.data.answer;
        this.state.lessonId = this.props.data.lesson_id;
        this.state.multiple_choice_image_id = this.props.data.question_id;

        this.Add = this.Add.bind(this);
        this.Remove = this.Remove.bind(this);

    }

    handlePreview = () => {
        this.setState({ prev_review: false })
    }

    handleReviewLastSlide = () => {
        this.handlePrevButton(this.props.current_index - 1)
        this.state.prevbutton = true
    }

    handleRestartLesson = () => {
        this.handlePrevButton(0)
        this.state.prevbutton = true
    }

    handleCancel = () => {
        this.setState({ prev_review: true })
    }

    handleAnswerpopup = () => {
        this.setState({ answer_popup: false })

        let arra1 = this.state.selected_value;
        let arra2 = this.state.user;
        arra2.filter(item => {
            if (item.multiple_choice_image_id == arra1) {
                if (item.answer == 'true') {
                    this.setState({ answer_reinforcement: this.state.correctAns })
                } else {
                    this.setState({ answer_reinforcement: this.state.incorrectAns })
                }
            }
        })
    }

    DisableButtonFunction = (e) => {
        this.setState({
            done_button_state: false,
            done_button_name: this.state.done_text,
            selected_value: e.target.value
        })
    }

    handleDoneButton = (current_index) => {
        this.props.nextQuestion(current_index)
    }

    handlePrevButton = (current_index) => {
        this.props.nextQuestion(current_index)
    }

    handleSubmit = (e) => {

        e.preventDefault();
        if (this.state.title.trim().length < 2 || this.state.title.trim().length > 250) {
            document.getElementById("title").focus();
        } else if (this.state.correctAns.trim().length < 2 || this.state.correctAns.trim().length > 50) {
            document.getElementById("correct_reinforcement").focus();
        } else if (this.state.incorrectAns.trim().length < 2 || this.state.incorrectAns.trim().length > 50) {
            document.getElementById("incorrect_reinforcement").focus();
        } else if (this.state.prompt.trim().length < 2 || this.state.prompt.trim().length > 50) {
            document.getElementById("prompt").focus();
        } else if (this.state.done_text.trim().length < 2 || this.state.done_text.trim().length > 30) {
            document.getElementById("done_text").focus();
        } else {

            let data = [];

            this.state.user.map((item, i) => (
                data.push({ options: item.options, answer: item.answer })
            ))
            let Multiple_choice_image = JSON.stringify(
                {
                    lesson_id: this.state.lessonId,
                    title: this.state.title,
                    prompt: this.state.prompt,
                    done_text: this.state.done_text,
                    answer: this.state.answer,
                    answer_text: this.state.answerText,
                    correct_reinforcement: this.state.correctAns,
                    incorrect_reinforcement: this.state.incorrectAns,
                    multiple_choice_image_id: this.state.multiple_choice_image_id,
                    options_data: data,

                });
            fetch(API + 'edit_multi_choice_image.php',
                {
                    method: 'POST',

                    body: Multiple_choice_image
                }).then((response) => response.json()).then((responseJsonFromServer) => {


                    var x = document.getElementById("snackbar");
                    x.className = "show";
                    setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);

                    if (responseJsonFromServer.result === 'success') {
                        x.innerHTML = responseJsonFromServer.msg;
                        setTimeout(() => {
                            this.props.handleUpdateQuetionData();
                        }, 2000);
                    } else {
                        x.innerHTML = responseJsonFromServer.msg;
                    }

                }).catch((error) => {
                    if (error.message == 'Failed to fetch') {
                        this.setState({ networkError: true })
                    }
                });

        }
    }

    titleValidation = (e) => {
        let targetId = e.target.id;
        let value = e.target.value;
        if (value.trim().length == 0) {
            document.getElementsByClassName('error_title')[0].innerHTML = "Title is required.";
            document.getElementsByClassName('error_title')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 250) {
            document.getElementsByClassName('error_title')[0].innerHTML = 'Title must be between 2 to 250 character.';
            document.getElementsByClassName('error_title')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else {
            e.target.classList.remove('error');
            document.getElementsByClassName('error_title')[0].innerHTML = "";
            document.getElementsByClassName('error_title')[0].style.display = 'none';
        }
    }

    contentValidation = (i, e) => {
        let targetId = e.target.id;
        let value = e.target.files;

        if (value.trim().length == 0) {
            document.getElementsByClassName('error_content' + i)[0].innerHTML = "Options is required.";
            document.getElementsByClassName('error_content' + i)[0].style.display = 'block';
            e.target.classList.add('error');
            this.setState({ contentValidation: true })
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 30) {
            document.getElementsByClassName('error_content' + i)[0].innerHTML = 'Options must be between 2 to 30 character.';
            document.getElementsByClassName('error_content' + i)[0].style.display = 'block';
            e.target.classList.add('error');
            this.setState({ contentValidation: true })
            document.getElementById(targetId).focus();
        } else {
            document.getElementsByClassName('error_content' + i)[0].innerHTML = "";
            document.getElementsByClassName('error_content' + i)[0].style.display = 'none';
            e.target.classList.remove('error');
            this.setState({ contentValidation: false })
        }
    }

    correct_reinforcementValidation = (e) => {
        let targetId = e.target.id;
        let value = e.target.value;
        if (value.trim().length == 0) {
            document.getElementsByClassName('error_correct_reinforcement')[0].innerHTML = "Correct reinforcement is required.";
            document.getElementsByClassName('error_correct_reinforcement')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 50) {
            document.getElementsByClassName('error_correct_reinforcement')[0].innerHTML = 'Correct reinforcement must be between 2 to 50 character.';
            document.getElementsByClassName('error_correct_reinforcement')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else {
            e.target.classList.remove('error');
            document.getElementsByClassName('error_correct_reinforcement')[0].innerHTML = "";
            document.getElementsByClassName('error_correct_reinforcement')[0].style.display = 'none';
        }
    }

    incorrect_reinforcementValidation = (e) => {
        let targetId = e.target.id;
        let value = e.target.value;
        if (value.trim().length == 0) {
            document.getElementsByClassName('error_incorrect_reinforcement')[0].innerHTML = "Incorrect reinforcement is required.";
            document.getElementsByClassName('error_incorrect_reinforcement')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 50) {
            document.getElementsByClassName('error_incorrect_reinforcement')[0].innerHTML = 'Incorrect reinforcement must be between 2 to 50 character.';
            document.getElementsByClassName('error_incorrect_reinforcement')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else {
            e.target.classList.remove('error');
            document.getElementsByClassName('error_incorrect_reinforcement')[0].innerHTML = "";
            document.getElementsByClassName('error_incorrect_reinforcement')[0].style.display = 'none';
        }
    }

    promptValidation = (e) => {
        let targetId = e.target.id;
        let value = e.target.value;
        if (value.trim().length == 0) {
            document.getElementsByClassName('error_prompt')[0].innerHTML = "Prompt is required.";
            document.getElementsByClassName('error_prompt')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 50) {
            document.getElementsByClassName('error_prompt')[0].innerHTML = 'Prompt must be between 2 to 50 character.';
            document.getElementsByClassName('error_prompt')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else {
            e.target.classList.remove('error');
            document.getElementsByClassName('error_prompt')[0].innerHTML = "";
            document.getElementsByClassName('error_prompt')[0].style.display = 'none';
        }
    }

    done_textValidation = (e) => {
        let targetId = e.target.id;
        let value = e.target.value;
        if (value.trim().length == 0) {
            document.getElementsByClassName('error_done_text')[0].innerHTML = "Done text is required.";
            document.getElementsByClassName('error_done_text')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else if (value.trim().length < 2 || value.trim().length > 30) {
            document.getElementsByClassName('error_done_text')[0].innerHTML = 'Done text must be between 2 to 30 character.';
            document.getElementsByClassName('error_done_text')[0].style.display = 'block';
            e.target.classList.add('error');
            document.getElementById(targetId).focus();
        } else {
            e.target.classList.remove('error');
            document.getElementsByClassName('error_done_text')[0].innerHTML = "";
            document.getElementsByClassName('error_done_text')[0].style.display = 'none';
        }
    }

    handleChangeTitle = (e) => {
        this.setState({ title: e.target.value })
    }

    handleChangeSubTitle = (e) => {
        this.setState({ subtitle: e.target.value })
    }

    handleClick = (id) => (e) => {
        this[`textInput${id}`].focus();
        this[`textInput${id}`].click();
    }

    handleChangeContent = (i, e) => {
        if (e.target.files[0]) {
            var fileName = e.target.files[0].name;
            var idxDot = fileName.lastIndexOf(".") + 1;
            var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
            if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {

                let users = this.state.user;
                users.map((item, index) => {
                    if (index == i) {
                        let files = e.target.files;
                        item.ImageName = fileName
                        let reader = new FileReader();
                        reader.readAsDataURL(files[0])
                        reader.onload = (e) => {
                            if (e.target.result) {
                                item.options = e.target.result;
                            }
                        }
                    }
                })

                this.setState({ user: users });

                var formdata = new FormData();
                formdata.append('file1', document.getElementById('file1' + i).files[0]);

                var request = new XMLHttpRequest();
                var x = document.getElementById("Video_uploading_percent" + i)

                request.upload.addEventListener('progress', function (e) {
                    var file1Size = document.getElementById('file1' + i).files[0].size;
                    if (e.loaded <= file1Size) {
                        var percent = Math.round(e.loaded / file1Size * 100);
                        var loader = document.getElementById('progress-bar-file1' + i)
                        loader.style.width = `${percent}%`;
                        x.innerHTML = percent + '%'
                    }

                    if (e.loaded == e.total) {
                        var loader = document.getElementById('progress-bar-file1' + i)
                        loader.style.width = `${100}%`;
                        x.innerHTML = 100 + '%'
                    }
                });
                request.open('post', '/echo/html/');
                request.timeout = 45000;
                request.send(formdata);
            } else {
                this.setState({ image_error_popup: true })
            }
        }
    }

    handleCorrectOption = async (i, e) => {
        let value = String(e.target.checked);

        let users = this.state.user;
        users.map((item, index) => {

            if (index == i) {
                item.answer = value;
            } else {
                item.answer = 'false';
            }
        })

        await this.setState({ user: users });

    }

    handleChangeAnswerText = (e) => {
        this.setState({ answerText: e.target.value });
    }

    handleChangeCorrectAns = (e) => {
        this.setState({ correctAns: e.target.value });
    }

    handleChangeIncorrectAns = (e) => {
        this.setState({ incorrectAns: e.target.value });
    }

    handleChangePrompt = (e) => {
        this.setState({ prompt: e.target.value });
    }

    handleChangeDoneText = (e) => {
        this.setState({ done_text: e.target.value })
    }

    Add() {
        let add = this.state.user;
        if (this.state.user.length < 4) {
            let newu = { options: 'data:image/png;base64,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', answer: 'false' }

            add.push(newu)
            this.setState({
                user: add,
            })
        }
    }

    Remove = async () => {
        var i = this.state.changeSectionStatus;
        let users = this.state.user;
        if (this.state.user.length > 2) {
            users.splice(i, 1);
            await this.setState({ user: users, PublishedSectionPopup: false });
        }
    }

    handleSectionStatusPopupOpen(item) {
        this.setState({
            PublishedSectionPopup: true,
            changeSectionStatus: item
        });
    }

    handlePublishedSectionPopup = () => {
        this.setState({ PublishedSectionPopup: false });
    }

    render() {
        if (this.state.networkError) {
            return <NoInternet />
        } else {
            return (
                <div className="row text-center">
                    <div className="col-lg-5 col-md-5 col-sm-12">
                        <div className="card card-sm">
                            <div className="card-content block-xl"  >
                                <div className="body-container" style={styles.body}>
                                    <div className="container-fluid" style={{ height: 550, padding: 0, backgroundPosition: 'center', backgroundSize: 'cover', backgroundImage: `url(${this.state.course_image})` }}>
                                        <div style={{ backgroundColor: 'rgba(0,0,0,0.5)', height: 550, paddingTop: 10, paddingLeft: 15, paddingRight: 15 }}>
                                            <div className="row text-center">
                                                <div className="col-2">
                                                    <img src={require('../../assets/pta-logo2.png')} style={{ width: 30, height: 30 }} />
                                                </div>
                                                <div className="col-6" style={{ paddingTop: 15 }}>
                                                    <hr color='#fff' />
                                                </div>
                                                <div className="col-4">
                                                    <div style={styles.dot_btn}>
                                                        <label style={{ color: '#fff', fontSize: 15, padding: 5 }}>{this.props.current_index + 1} / {this.props.que_count}</label>
                                                        <img onClick={this.handlePreview} src={require('../../assets/Dot.png')} style={{ width: 25, height: 25, marginTop: -3, marginLeft: 10, cursor: 'pointer' }} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ height: 380, fontSize: 20, overflowY: 'auto' }}>
                                                <div>
                                                    <h5 style={{ color: '#fff', paddingBottom: 10 }}> {this.state.title}</h5>
                                                    <div className="d-flex flex-wrap">
                                                        {this.state.user.map((item, i) => (
                                                            <div key={i} style={styles.radio} className="text-left" >
                                                                <label style={{ width: '100%', height: 120 }}>
                                                                    <img src={item.options} style={{ maxHeight: '90%', maxWidth: '100%' }} />
                                                                    <div className="text-right">
                                                                        <input type="radio" name="option" onClick={this.DisableButtonFunction} value={item.multiple_choice_image_id} disabled={!this.state.answer_popup} />&nbsp;
                                                            </div>
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                <hr color='#fff' />
                                                <div className="text-center">
                                                    <button className="btn" disabled={this.state.done_button_state} onClick={() => { this.handleAnswerpopup() }} style={this.state.done_button_state ? styles.disable_done_btn : styles.done_btn}>
                                                        {this.state.done_button_name}
                                                    </button>
                                                </div>
                                                <div style={{ backgroundColor: '#fff', visibility: this.state.answer_popup ? "hidden" : "visible", marginTop: -200, position: 'relative', marginLeft: -15, marginRight: -15, padding: 15, borderTop: 'solid', borderTopColor: 'rgba(0,0,0,0.4)', borderTopWidth: 5 }}>
                                                    <div style={{ overflowY: 'auto', height: 95 }}>
                                                        <p className="text-left"><strong>{this.state.answer_reinforcement}</strong></p>
                                                        <div className="text-left">
                                                            <p>{this.state.answerText}</p>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                                                        <div className="col-6">
                                                            <Button style={styles.continue_button} onClick={() => { this.handleDoneButton(this.props.current_index + 1) }} block>Continue</Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{ backgroundColor: '#34baeb', backgroundPosition: 'center', backgroundSize: 'cover', zIndex: 15, height: 550, top: -30, left: -30, margin: 30, visibility: this.state.prev_review ? "hidden" : "visible", position: 'absolute', paddingTop: 40 }}>
                                            <div>
                                                <div style={{ paddingRight: 50, paddingLeft: 50, paddingTop: 65 }}>
                                                    <div className="text-center">
                                                        <button onClick={this.handleReviewLastSlide} className="btn" style={styles.previewbutton}>
                                                            Review last slide
                                                    </button>
                                                    </div>
                                                    <div className="text-center">
                                                        <button onClick={this.handleRestartLesson} className="btn" style={styles.previewbutton}>
                                                            Restart lesson
                                                    </button>
                                                    </div>
                                                    <div className="text-center">
                                                        <button onClick={this.handleCancel} className="btn" style={styles.previewbutton}>
                                                            Cancel
                                                    </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row col-12" style={{ paddingTop: 10, backgroundColor: '#fff', marginLeft: 0.1 }}>
                                <div className="col-4">
                                    <Button variant="default" onClick={() => { this.handlePrevButton(this.props.current_index - 1) }} className="btn btn-light" inline-block="true" style={{ marginBottom: 10 }}><Icon icon={smallLeft} size={20} /></Button>
                                </div>
                                <div className="col-4 text-center" style={{ paddingTop: 10 }}>
                                    <span >Slide {this.props.current_index + 1}</span>
                                </div>
                                <div className="col-4">
                                    <Button onClick={() => { this.handleDoneButton(this.props.current_index + 1) }} variant="default" className="btn btn-light" inline-block="true" style={{ marginBottom: 10 }}><Icon icon={smallRight} size={20} /></Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-7 col-sm-12">
                        <div className="card-sm" >
                            <form>
                                <div className="card-content block-xl" style={{ height: 550, overflowY: 'scroll', overflowX: 'scroll' }}>
                                    <h5 className="text-left" style={{ paddingBottom: 10 }}>Multiple Choice</h5>
                                    <div className="text-left">
                                        <div className="form-group">
                                            <div className="input-group-prepend" style={styles.textbox}>
                                                <span className="input-group-text" style={styles.text}>Title*</span>
                                            </div>
                                            <input type="text" className="form-control" id="title" value={this.state.title} minLength={2} maxLength={250} onChange={this.handleChangeTitle} onBlur={this.titleValidation} />
                                            <label className="input-error error_title"></label>
                                        </div>
                                        <hr />
                                        <div>
                                            <Accordion style={{ textAlign: 'left' }} defaultActiveKey="0">
                                                <div>
                                                    <div eventkey="0">
                                                        <h5>Answers</h5>
                                                    </div>
                                                    <Accordion.Collapse eventKey="0">
                                                        <div>
                                                            {this.state.user.map((item, i) => (
                                                                <div key={i} style={{ padding: 10, marginBottom: 10, backgroundColor: '#fff' }}>
                                                                    <div className="form-group">
                                                                        <div className="input-group-prepend" style={styles.textbox}>
                                                                            <span className="input-group-text" style={styles.text}>Image*</span>
                                                                            <span className="pl-2 pt-1" style={styles.text}>{item.ImageName}</span>
                                                                        </div>

                                                                        <input
                                                                            key={i}
                                                                            id={"file1" + i}
                                                                            style={{ display: 'none' }}
                                                                            ref={input => { this[`textInput${i}`] = input }}
                                                                            className="upload"
                                                                            className="mr-3"
                                                                            onChange={this.handleChangeContent.bind(this, i)}
                                                                            onBlur={this.contentValidation.bind(this, i)}
                                                                            type="file"
                                                                            multiple
                                                                            encType="multipart/form-data"
                                                                            accept="image/*"
                                                                            data-key={i}
                                                                        />
                                                                        <Button variant="default" style={{ backgroundColor: '#E6EBF0' }} data-key={i} onClick={this.handleClick(i)} block>
                                                                            Click or drag a new file here to change image
                                                                    </Button>
                                                                        <div className="row col-12 m-0" style={{ padding: '15px 5px' }}>
                                                                            <div className="progress-wrapper flex-column d-flex justify-content-center p-0 pr-1 col-11">
                                                                                <div id={"progress-bar-file1" + i} className="progress"></div>
                                                                            </div>
                                                                            <div className="col-1 p-0" id={"Video_uploading_percent" + i}></div>
                                                                        </div>
                                                                    </div>
                                                                    <label>
                                                                        <input type="radio" name="option" defaultChecked={item.answer == 'true' ? true : false} onClick={this.handleCorrectOption.bind(this, i)} style={{ marginRight: 20, width: 20, height: 20 }} />
                                                                        <strong>Correct</strong>
                                                                    </label>
                                                                    <div>
                                                                        <Button variant="default" disabled={this.state.user.length == 2} style={{ backgroundColor: '#E6EBF0' }} block onClick={this.handleSectionStatusPopupOpen.bind(this, i)}>
                                                                            <Icon size={20} icon={trashO} style={{ paddingRight: 10 }} />
                                                                        Remove this section
                                                                    </Button>
                                                                    </div>
                                                                </div>
                                                            ))}

                                                            <Modal size="sm" show={this.state.PublishedSectionPopup} onHide={this.handlePublishedSectionPopup}>
                                                                <Modal.Body>Are you sure you want to remove this?</Modal.Body>
                                                                <Modal.Footer>
                                                                    <Button variant="secondary" onClick={this.handlePublishedSectionPopup}>No</Button>
                                                                    <Button style={styles.confirmButton} onClick={() => this.Remove()}>Yes</Button>
                                                                </Modal.Footer>
                                                            </Modal>

                                                            <div style={{ marginTop: 10, color: '#fff' }}>
                                                                <Button variant="default" disabled={this.state.user.length == 4} onClick={this.Add.bind(this)} style={{ backgroundColor: '#223042', color: '#fff' }} block >
                                                                    <Icon size={20} icon={plus} style={{ paddingRight: 10, color: '#fff' }} />
                                                                Add a section
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </Accordion.Collapse>
                                                </div>
                                            </Accordion>
                                        </div>
                                        <hr />
                                        <div>
                                            <Accordion style={{ textAlign: 'left' }} defaultActiveKey="0">
                                                <div>
                                                    <div as={Card.Body} eventkey="0">
                                                        <h5>Answer</h5>
                                                    </div>
                                                    <Accordion.Collapse eventKey="0">
                                                        <div>
                                                            {/* <div className="form-group">
                                                            <div className="input-group-prepend" style={styles.textbox}>
                                                                <text className="input-group-text" style={styles.text}>Correct Answer</text>
                                                            </div>
                                                            <input type="text" className="form-control" id="correct_answer" value={this.state.answer} minLength={2} maxLength={30} onChange={this.handleAnswer} onBlur={this.correct_answerValidation} />
                                                            <label className="input-error error_correct_answer"></label>
                                                        </div> */}
                                                            <div className="form-group">
                                                                <div className="input-group-prepend" style={styles.textbox}>
                                                                    <span className="input-group-text" style={styles.text} >Answer Text</span>
                                                                </div>
                                                                <textarea type="text" className="form-control" maxLength={150} value={this.state.answerText} onChange={this.handleChangeAnswerText} />
                                                            </div>
                                                            <div className="form-group">
                                                                <div className="input-group-prepend" style={styles.textbox}>
                                                                    <span className="input-group-text" style={styles.text}>Correct Reinforcement*</span>
                                                                </div>
                                                                <input type="text" className="form-control" id="correct_reinforcement" value={this.state.correctAns} minLength={2} maxLength={50} onChange={this.handleChangeCorrectAns} onBlur={this.correct_reinforcementValidation} />
                                                                <label className="input-error error_correct_reinforcement"></label>
                                                            </div>
                                                            <div className="form-group">
                                                                <div className="input-group-prepend" style={styles.textbox}>
                                                                    <span className="input-group-text" style={styles.text}>Incorrect Reinforcement*</span>
                                                                </div>
                                                                <input type="text" className="form-control" id="incorrect_reinforcement" value={this.state.incorrectAns} minLength={2} maxLength={50} onChange={this.handleChangeIncorrectAns} onBlur={this.incorrect_reinforcementValidation} />
                                                                <label className="input-error error_incorrect_reinforcement"></label>
                                                            </div>
                                                        </div>
                                                    </Accordion.Collapse>
                                                </div>
                                            </Accordion>
                                        </div>
                                        <hr />
                                        <div className="form-group">
                                            <div className="input-group-prepend" style={styles.textbox}>
                                                <span className="input-group-text" style={styles.text}>Prompt*</span>
                                            </div>
                                            <input type="text" className="form-control" id="prompt" value={this.state.prompt} minLength={2} maxLength={50} onChange={this.handleChangePrompt} onBlur={this.promptValidation} />
                                            <label className="input-error error_prompt"></label>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-group-prepend" style={styles.textbox}>
                                                <span className="input-group-text" style={styles.text}>Done text*</span>
                                            </div>
                                            <input type="text" className="form-control" id="done_text" value={this.state.done_text} minLength={2} maxLength={30} onChange={this.handleChangeDoneText} onBlur={this.done_textValidation} />
                                            <label className="input-error error_done_text"></label>
                                        </div>
                                        <hr />
                                    </div>
                                </div>
                                <div className="text-left " style={{ paddingTop: 10, paddingBottom: 10 }}>
                                    <button className="btn btn-dark" style={{ width: 150 }} onClick={this.handleSubmit}>Save</button>
                                    <div id="snackbar"></div>
                                    <Modal size="sm" show={this.state.image_error_popup} onHide={() => this.setState({ image_error_popup: false })}>
                                        <Modal.Body>Only images are accepted.</Modal.Body>
                                        <Modal.Footer>
                                            {/* <Button variant="secondary" onClick={this.handleClose}>No</Button> */}
                                            <Button variant="primary" onClick={() => this.setState({ image_error_popup: false })} block>Ok</Button>
                                        </Modal.Footer>
                                    </Modal>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )
        }
    }
}